<template>
  <custom-dialog
    class="update-sim-state-dialog"
    width="1400px"
    :title="model.title"
    :visible="visible"
    v-on="$listeners"
  >
    <div class="dialog-body">
      <custom-table
        :data="tableList"
        :column="tableColumn"
        height="400px"
        @filter="filterChange"
        @sort="sortChange"
        :slots="['newSimState', 'action']"
      >
        <!-- dataFilter   -->
        <template v-slot:newSimState="scope">
          <custom-select
            code="sim_status"
            v-model="scope.row.newSimState"
            :filterOptions="scope.row"
            :dataFilter="dataFilter"
          ></custom-select>
        </template>
        <template v-slot:action="scope">
          <el-button
            type="text"
            size="mini"
            @click="del(scope.$index)"
          >{{$t('Common.com_delete')}}</el-button>
        </template>
      </custom-table>
    </div>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="closeDialog">
        {{$t('Common.com_cancel')}}
      </el-button>
      <el-button
        type="primary"
        @click="onConfirm"
      >
        {{$t('Common.com_confirm')}}
      </el-button>
    </div>
  </custom-dialog>
</template>

<script>
import dialogMixins from '@/mixins/dialog_mixins';
import apis from '@/utils/apis.js';

export default {
  mixins: [dialogMixins],
  props: {},
  data() {
    return {
      tableCode: 'update_sim_state',
      tableList: [],
    };
  },
  methods: {
    dataFilter(list, row) {
      /**
       * 下拉选择项：10-已激活，20-已停用，50-已失效
          新SIM状态不能与旧状态一致
          如果row是已失效，则只能选择：激活
       */
      const whiteList = `${row.simState}` === '50' ? ['10'] : [
        '10',
        '20',
        '50'
      ];
      const arr = list.filter(item => whiteList.includes(`${item.value}`));
      return arr.filter(item => item.value !== `${row.simState}`);
    },
    closeDialog() {
      this.visible = false;
    },
    onConfirm() {
      const unSelected = this.tableList.some(item => !item.newSimState);
      if (unSelected) {
        this.$message({
          message: this.$t('dms_update_sim_state_dialog.qxzxSIMzt'),
          type: 'error'
        });
        return;
      }
      const reqData = this.getSubmitReqData();
      this.$postJSON(apis.simStateBatchUpdate, reqData).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success'
        });
        this.$emit('success');
        this.closeDialog();
      });
    },
    init() {
      this.getTableColumn();
      const simIds = this.model.data.selectedSim.map(item => item.simId);
      this.$getJSON(apis.simListByIds, { simIds }).then((res) => {
        this.tableList = res.data;
      });
    },
    del(index) {
      this.tableList.splice(index, 1);
    },
    getSubmitReqData() {
      const ret = this.tableList.map((item) => {
        const obj = {
          iccid: item.iccid,
          imsi: item.imsi,
          simId: item.simId,
          simState: item.newSimState
        };
        return obj;
      });
      return ret;
    }

  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss">
.update-sim-state-dialog {
  .btn-content {
    padding: 10px 0;
    .add-relation-data {
      width: 100%;
      margin: 10px 0;
      background: whitesmoke;
      border: 1px dashed #e4e4e4;
      color: #333333;
      font-size: 12px;
      .icon-add {
        color: #00afff;
        font-size: 10px;
        margin-right: 0px;
      }
    }
  }
}
</style>
